import React from 'react'

import InfoIcon from '@material-ui/icons/Info'
import { makeStyles } from '@material-ui/core/styles'

import t from '../../../translations'

// Wygląd jak komunikat informacyjny z FlashToasts: białe tło, ramka 2 px w kolorze głównym, ciemny tekst,
// padding SnackbarContent (6px 16px) pomniejszony o ramkę. Stoi nad przyciskiem wysyłania w zwykłym układzie strony,
// więc niczego nie zasłania i nie znika sam — chowa się, gdy kursant poprawi wszystkie wskazane pytania.
const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.typography.body2,
    display: 'flex',
    alignItems: 'flex-start',
    backgroundColor: theme.palette.common.white,
    color: '#0A0A0A',
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: theme.shape.borderRadius,
    padding: '4px 14px',
    marginBottom: theme.spacing(2),
  },
  icon: {
    fontSize: 20,
    opacity: 0.9,
    color: theme.palette.primary.main,
    marginRight: theme.spacing(1),
    marginTop: 8,
    flexShrink: 0,
  },
  message: {
    padding: '8px 0',
  },
  list: {
    margin: '4px 0 0',
    paddingLeft: '1.25rem',
  },
}))

const ValidationSummary = ({ missingCount, lowMarkLabels }) => {
  const classes = useStyles()

  if (!missingCount && lowMarkLabels.length === 0) return null

  return (
    <div id={'walidacja-podsumowanie'} role={'alert'} className={classes.root}>
      <InfoIcon className={classes.icon} />
      <div className={classes.message}>
        {
          missingCount > 0 ?
            t.pollView.fillRequired
            :
            <>
              {t.pollView.fillRequiredReasons}
              <ul className={classes.list}>
                {lowMarkLabels.map(label => <li key={label}>{label}</li>)}
              </ul>
            </>
        }
      </div>
    </div>
  )
}

export default ValidationSummary
